import type { FaireProductEntity } from "../../entity_types/product";

export const p_f94v9j8mvk: FaireProductEntity = {
  token: "p_f94v9j8mvk",
  type: "product",
  name: "Dancing Socks | Assorted Stripe",
  brandToken: "b_cpqsk65pdp",
  brandName: "Soul Shine Maine",
  imageUrl:
    "https://cdn.faire.com/fastly/5e6d6f58f6267bf0fa4988dfb31cb2bb4ab7aefddd04e3c9e30b664f86a754b4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0ba8ecf58c74d9483e9852ec002ced7f95e5c2a6fc761516006fb2c3d8edf08f.jpeg",
    "https://cdn.faire.com/fastly/1dcf4598aaf681763c0ce76c2e03c7598dc6187b8e43c842772878ba7af86ecf.jpeg",
  ],
  priceDollars: 10,
  description:
    "Check out our Psychedelic Prankster Socks!\n\nWe call them our Dancing Socks! And they are for sure a house favorite, festival must have!\n\nSoft and comfy and solid for miles of stomping!\n\n• Cotton Socks in Size 11-13 Mens/Womens.\n• 3 pair\n• Colors chosen at random\n• 90% Cotton/Lycra Blend\n• Assorted colors available!\n• Hand Dyed and Made in the USA!\n\n• All our dyes are fiber reactive and stead-fast to keep you looking good wash after wash!\n\n• Due to the organic and unique nature of tie dye all items are one of a kind and you will receive an item similar and color and style to the one shown above!",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:23.512Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
